var map = {
	"./bn.json": "8782",
	"./en.json": "edd4",
	"./gu.json": "fb8f",
	"./hi.json": "7a03",
	"./kn.json": "5914",
	"./ml.json": "b7ff",
	"./mr.json": "18df",
	"./pa.json": "f2b6",
	"./ta.json": "2393",
	"./te.json": "143f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";